import React, { Component } from "react"
import PropTypes from "prop-types"

export default class Pagination extends Component {
  constructor(props) {
    super(props)

    this.state = { pageNumber: 1 }
  }

  render() {
    const { currentPage, totalPages, previousButtonText, nextButtonText } =
      this.props

    return (
      <div className="pagination">
        {/* only show the previous button on pages that are not the first page */}
        {this.props.currentPage > 0 ? (
          <button
            className="cta-block__button previous btn-ghost"
            onClick={(e) => this.props.onClick(e, currentPage - 1)}
          >
            {`${previousButtonText}`}
          </button>
        ) : null}

        {/* only show the next button on pages that are not the last page */}
        {currentPage + 1 !== totalPages ? (
          <button
            className="cta-block__button next btn-ghost"
            onClick={(e) => this.props.onClick(e, currentPage + 1)}
          >
            {nextButtonText}
          </button>
        ) : null}
      </div>
    )
  }
}

Pagination.propTypes = {
  onClick: PropTypes.func,
  currentPage: PropTypes.number,
  previousButtonText: PropTypes.string,
  nextButtonText: PropTypes.string,
  totalPages: PropTypes.number,
}
